import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { InlineEditableTitle } from 'modules/trainings/components/content/items/shared/fields/InlineEditableTitle'
import { contentContainer } from 'modules/trainings/components/content/styles.vanilla.css'
import { ContentRenderProps } from 'modules/trainings/components/content/types'
import { ContentModule } from 'modules/trainings/lib/content/Module'

import {
  moduleContainerFullscreen,
  moduleContainerPreview,
  titleStyle,
  titleStyleFullscreen,
} from './ModuleView.vanilla.css'

const ModuleView = ({
  contentItem,
  readOnly = false,
  onContentChange,
  isFullscreen = false,
}: ContentRenderProps<ContentModule>) => {
  const position = isFullscreen ? 'fixed' : undefined
  const containerClassName = isFullscreen ? moduleContainerFullscreen : moduleContainerPreview
  const innerPaddingX = isFullscreen ? undefined : 's32'
  const textMaxWidth = isFullscreen ? undefined : 's600'
  const innerClassName = isFullscreen ? contentContainer : ''
  const textStyle = isFullscreen ? titleStyleFullscreen : titleStyle

  const handleTitleChange = (value: string) => {
    contentItem.title = value
    onContentChange?.()
  }

  const content = (
    <Box
      width="full"
      height="full"
      alignItems="center"
      justifyContent="center"
      position={position}
      className={containerClassName}
    >
      <Box width="full" paddingX={innerPaddingX} className={innerClassName}>
        <Box maxWidth={textMaxWidth} style={{ margin: '0 auto' }}>
          {readOnly ? (
            <F0Text content={contentItem.title} variant="body" style={textStyle} />
          ) : (
            <InlineEditableTitle
              value={contentItem.title}
              placeholder={i18n.t('trainings.content.module_modal.label_placeholder')}
              ariaLabel={i18n.t('trainings.content.module_modal.label_title')}
              style={textStyle}
              onChange={handleTitleChange}
            />
          )}
        </Box>
      </Box>
    </Box>
  )

  if (isFullscreen) {
    return content
  }

  return (
    <Box width="full" height="full" paddingTop="s16" paddingX="s64" paddingBottom="s64">
      {content}
    </Box>
  )
}

export { ModuleView }
